<template lang="pug">
div
  algorithm-tabs.negative-margin(
    ref="tabAlgorithms"
    :selectedAlgorithm="selectedSubTab"
    @selected="changeSubTab"
    :mini="true"
    :localAlgorithms="listOfAlgorithms"
  )

  .info-miner.w100.subtab(
    v-show="selectedSubTab.code === item.code"
    v-for="item in listOfAlgorithms"
  ) 

    template
      .table-workers-0.feature-helvetica.has-text-centered(v-if="item.hasNoWorkers")
        br
        span You have no {{ item.name }} workers online.
        .mt-10
          span If you are sending valid shares, 
          br
          span kindly wait some minutes for your workers to show up.
        .mt-10
          span You can also check 
          router-link.info-link(to="/support") our support center
          span  or try 
          router-link.info-link(to="/wizard") our wizard 🧙‍♂️
          span  for getting started
      .columns(v-if="!item.hasNoWorkers")
        .column
          ChartHashrate(
            v-if="item.showGraph"
            :options="item.chartOptions",
            :series="item.chartSeries",
            :preUnit="item.preUnitOfMeasurement",
            :minimumUnit="item.minimumUnitOfMeasurement"
          )
        .column
          table.table.is-fullwidth.table-workers
            thead
              tr
                th 
                  span Worker
                th.has-text-right.column-100
                  .hint--top-left.hint--large.has-text-left.cursor-pointer(
                    v-if="item.hasReportedHashrate"
                    aria-label='Current & (Calculated) hash rate, based on submitted shares, your calculated (effective) hr may take up to an hour get on par with your Current (reported) hash rate, depending on your mining stability. Current hash rate is informative, calculated hash rate is used for rewards.'
                  ) 
                    span Speed
                    i.fa.fa-info-circle.ml-5
                  div(v-else)
                    span Speed
            tbody
              tr(
                v-for="o in item.workers"
                :class="{'offline': !o.online}"
              )
                td
                  span {{ o.name }}
                  template(v-if="o.referral")
                    div
                    span.referral_code_lbl.hint--right(aria-label="Referral Code") {{ o.referral }}
                td.has-text-right
                  template(v-if="item.hasReportedHashrate")
                    span {{ o.transformedRhr }} {{ o.transformedUnitRhr | capitalize }}/s 
                    span.opacity-07
                      span (
                      span {{ o.transformedChr }} {{ o.transformedUnitChr | capitalize }}/s
                      span )
                  template(v-else)
                    span {{ +o.transformedChr || +o.transformedRhr }} {{ o.transformedUnitChr | capitalize }}/s
          .has-text-left
            span Please note that your hash rate is based on your worker's past hour performance. It will stabilize 
            i after an hour of continuous mining


</template>

<script>
import { apiGet } from '../util/general'
import AlgorithmTabs from '../components/c_tab_algorithm_select'
import ChartHashrate from '../components/c_chart_hashrate'
export default {
  name: 'c_tab_workers',
  props: ['uuid'],
  components: {
    'algorithm-tabs': AlgorithmTabs,
    ChartHashrate
  },
  data() {
    return {
      hasNoWorkers: false,
      listOfAlgorithms: [
      ],
      selectedSubTab: {}
    }
  },
  created() {
    let vm = this
    // initialize list of algorithms
    let listOfAlgorithms = []
    for (let i = 0; i < vm.algos.length; i++) {
      let obj = {
        code: vm.algos[i].code,
        name: vm.algos[i].name,
        new: vm.algos[i].new,
        beta: vm.algos[i].beta,
        tags: vm.algos[i].tags,
        type: vm.algos[i].type,
        typeCode: vm.algos[i].typeCode,
        deactivated: vm.algos[i].deactivated,
        symbolDesc: vm.algos[i].symbolMerged || vm.algos[i].symbol,
        additionalTypes: vm.algos[i].additionalTypes,
        additionalTypesDescription: vm.algos[i].additionalTypesDescription,
        hasNoWorkers: true,
        workers: [],
        chartOptions: {},
        chartSeries: [],
        showGraph: false,
        hasReportedHashrate: vm.algos[i].hasReportedHashrate,
        unitOfMeasurement: vm.algos[i].unitOfMeasurement,
        preUnitOfMeasurement: vm.algos[i].preUnitOfMeasurement,
        minimumUnitOfMeasurement: vm.algos[i].minimumUnitOfMeasurement,
        minimumVramRequirement: vm.algos[i].minimumVramRequirement,
        warningMessage: vm.algos[i].warningMessage,
        warningDotMessage: vm.algos[i].warningDotMessage
      }
      listOfAlgorithms.push(obj)
    }

    vm.listOfAlgorithms = listOfAlgorithms
  },
  computed: {
    mode() {
      return this.$store.getters.mode
    },
    algos() {
      return this.$store.getters.algos
    },
    chartPeriod() {
      return this.$store.getters.chartPeriod
    },
    logChart() {
      return this.$store.getters.logChart
    }
  },
  watch: {
    mode(newValue, oldValue) {
      this.updateModeChart()
    }
  },
  methods: {
    fetch(algorithmSelected) {
      let vm = this
      if (!vm.uuid) return
      vm.$emit('startLoading')
      let url = '/v5/account/' + vm.uuid + '/workers'
      var obj = {}

      let goToSubtab = algorithmSelected || ''

      apiGet(vm, url, obj, function (data) {
        if (data.success) {
          let i = 0

          let anHourAgo = new Date();
          anHourAgo.setHours(anHourAgo.getHours() - vm.chartPeriod);

          let hasNoWorkers = true
          for (i = 0; i < vm.algos.length; i++) {
            if (data.data[vm.algos[i].code] && data.data[vm.algos[i].code].workers.length > 0) {
              hasNoWorkers = false
            }
          }

          if (hasNoWorkers) {
            vm.hasNoWorkers = true
            vm.$emit('hasNoWorkers')
          } else {
            vm.hasNoWorkers = false
            vm.$emit('hasWorkers')

            for (i = 0; i < vm.algos.length; i++) {
              let algorithm = vm.algos[i].code

              if (data.data[algorithm]) {
                if (data.data[algorithm].workers.length === 0) {
                  vm.listOfAlgorithms[i].hasNoWorkers = true
                  vm.listOfAlgorithms[i].workers = []
                } else {
                  vm.listOfAlgorithms[i].hasNoWorkers = false
                  vm.listOfAlgorithms[i].workers = vm.transformedUnitOfMeasurement(vm.algos[i].preUnitOfMeasurement, vm.algos[i].minimumUnitOfMeasurement, data.data[algorithm].workers)

                  if (!goToSubtab) goToSubtab = vm.algos[i].code

                  let options = vm.algos[i].chartOptions
                  options.fill.gradient.shade = vm.mode === 'dark' ? 'dark' : 'light'
                  options.xaxis.categories = data.data[algorithm].chart[vm.algos[i].xaxisCategoriesField].timestamps
                  options.xaxis.min = anHourAgo.getTime()
                  options.chart.foreColor = vm.mode === 'dark' ? '#ffffff' : '#373d3f'
                  options.yaxis.logarithmic = vm.logChart
                  options.yaxis.min = 0.01
                  options.chart.offsetY = 20

                  vm.listOfAlgorithms[i].chartOptions = options

                  let chartSeries = []
                  for (let j = 0; j < vm.algos[i].chartSeries.length; j++) {
                    chartSeries.push({
                      name: vm.algos[i].chartSeries[j].name,
                      data: data.data[algorithm].chart[vm.algos[i].chartSeries[j].field].data
                    })
                  }

                  vm.listOfAlgorithms[i].chartSeries = chartSeries

                  vm.listOfAlgorithms[i].showGraph = true
                }
              }
            }
          }

          if (!goToSubtab) goToSubtab = vm.listOfAlgorithms[0].code

          if (!algorithmSelected) {
            vm.changeSubTab(goToSubtab)
          }
        } else {
          vm.$store.dispatch('notifyError')
        }
      }, function (err) {
        console.error('Error:', err.message)
        vm.$store.dispatch('notifyError')
      }, function () {
        vm.$emit('stopLoading')
        vm.updateModeChart()
        if (!algorithmSelected) {
          setTimeout(function () {
            vm.$refs.tabAlgorithms.reScroll()
          }, 100)
        }
      })
    },
    changeSubTab(selectedSubTab, type) {
      let vm = this
      let selected = vm.listOfAlgorithms.find(element => element.code === selectedSubTab)
      if (vm.selectedSubTab.code === selected.code && type !== 'filter') {
        vm.fetch(vm.selectedSubTab.code)
      } else {
        vm.selectedSubTab = selected
      }

      // Hack for chart bug
      window.dispatchEvent(new Event('resize'))
    },
    copyToClipboard(text) {
      let vm = this
      const clipboardData = event.clipboardData || window.clipboardData || navigator.clipboard;
      clipboardData.writeText(text);
      vm.$store.dispatch('notifySuccess', 'Text copied!')
    },
    updateModeChart() {
      let vm = this
      for (let i = 0; i < vm.listOfAlgorithms.length; i++) {
        if (!vm.listOfAlgorithms[i].hasNoWorkers) {
          let categories = vm.listOfAlgorithms[i].chartOptions.xaxis.categories
          let xaxismin = vm.listOfAlgorithms[i].chartOptions.xaxis.min
          let options = JSON.parse(JSON.stringify(vm.algos[i].chartOptions))

          options.fill.gradient.shade = vm.mode === 'dark' ? 'dark' : 'light'
          options.xaxis.categories = categories
          options.xaxis.min = xaxismin
          options.chart.foreColor = vm.mode === 'dark' ? '#ffffff' : '#373d3f'

          vm.listOfAlgorithms[i].chartOptions = options
        }
      }
    },
    capitalize(value) {
      return value.substring(0, 1).toUpperCase() + value.substring(1, value.length)
    },
    transformedUnitOfMeasurement(preUnitOfMeasurement, minimumUnitOfMeasurement, workers) {
      for (var i = workers.length - 1; i >= 0; i--) {
        let preUnit = preUnitOfMeasurement

        let transformedChr = workers[i].chr
        while (+transformedChr >= 1000) {
          if (preUnit === 'z') {
            // Max unit
            break
          } else {
            if (preUnit === 'e') preUnit = 'z'
            else if (preUnit === 'p') preUnit = 'e'
            else if (preUnit === 't') preUnit = 'p'
            else if (preUnit === 'g') preUnit = 't'
            else if (preUnit === 'm') preUnit = 'g'
            else if (preUnit === 'k') preUnit = 'm'
            else if (preUnit === '') preUnit = 'k'

            transformedChr = (+transformedChr / 1000).toFixed(2)
          }
        }

        workers[i].transformedUnitChr = preUnit + minimumUnitOfMeasurement
        workers[i].transformedChr = transformedChr

        preUnit = preUnitOfMeasurement

        let transformedRhr = workers[i].rhr
        while (+transformedRhr >= 1000) {
          if (preUnit === 'z') {
            // Max unit
            break
          } else {
            if (preUnit === 'e') preUnit = 'z'
            else if (preUnit === 'p') preUnit = 'e'
            else if (preUnit === 't') preUnit = 'p'
            else if (preUnit === 'g') preUnit = 't'
            else if (preUnit === 'm') preUnit = 'g'
            else if (preUnit === 'k') preUnit = 'm'
            else if (preUnit === '') preUnit = 'k'

            transformedRhr = (+transformedRhr / 1000).toFixed(2)
          }
        }

        workers[i].transformedUnitRhr = preUnit + minimumUnitOfMeasurement
        workers[i].transformedRhr = transformedRhr
      }

      let workersSorted = workers.sort((a, b) => { return +b.chr - +a.chr; });

      return workersSorted
    }
  }
}
</script>

<style lang="stylus" scoped>
.negative-margin
  margin-top -4px
.tabs.is-subtab
  margin-top -14px
.referral_code_lbl
  color: #ccc;
  cursor: default;
  
  ul
    align-items: center;
    display: flex;
    flex-grow: 1;
    flex-shrink: 0;
    justify-content: flex-start;
    border-bottom: 1px;
    border-bottom-color: #dbdbdb;
    border-bottom-style: solid;
    border-bottom-width: 1px;
    align-items: flex-end;
  
    li
      display: block;
      a
        border: 1px solid transparent;
        color: #4a4a4a;
        display: flex;
        justify-content: center;
        margin-bottom: -1px;
        padding: 0.5em 1em;
        vertical-align: top;
      
  .great-tab
    display flex
    a
      border-radius: 4px 4px 0 0;
      width 100px
      color: #000;
      background-color: #fff;
      border-color: #dbdbdb;
      border-bottom-color: transparent!important;
      height 55px
      justify-content center
      align-items center
      .top-main-algo
        text-align center
        .algo-name
          font-weight 400
          font-size 15px
        
  .mini-container
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    max-height: 55px;
    width 100%
    margin-bottom 4px
    .mini-tab
      padding 0px 0px 0px 0px
      a
        padding 0px 0px 5px 0px
        .top-main-algo
          text-align center
          border-bottom: solid 1px #bababa;
          .algo-name
            font-size 13px

@media (max-width: 966px)
  .hide-less-966
    display none
  .show-less-966
    display flex
  
</style>



// WEBPACK FOOTER //
// c_tab_workers.vue?d3c9cbd0